(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["stact-door-collection"]) return;
  try {
    
function initDoorCollection() {
  const root = document.querySelector('.stact-doors');
  if (!root) return;
  const select = root.querySelector('[data-door-select]');
  const requested = new URLSearchParams(window.location.search).get('door_model');
  function chooseModel(handle) {
    if (!select) return;
    const option = Array.from(select.options).find(item => item.dataset.doorHandle === handle);
    if (option) select.value = option.value;
  }
  if (requested) chooseModel(requested);
  root.querySelectorAll('[data-door-model]').forEach(link => {
    if (link.dataset.doorBound) return;
    link.dataset.doorBound = 'true';
    link.addEventListener('click', () => chooseModel(link.dataset.doorModel));
  });
  const feedback = root.querySelector('[data-door-success], [data-door-errors]');
  if (feedback && !feedback.dataset.doorFocused) {
    feedback.dataset.doorFocused = 'true';
    feedback.focus({preventScroll: true});
    feedback.scrollIntoView({block: 'center'});
  }
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initDoorCollection);
else initDoorCollection();
document.addEventListener('shopify:section:load', initDoorCollection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stact-kitchen-page"]) return;
  try {
    
function initKitchenQuote(){const root=document.querySelector('.stact-kitchen');if(!root)return;const select=root.querySelector('[data-kitchen-select]');root.querySelectorAll('[data-kitchen-choice]').forEach(link=>{if(link.dataset.kitchenBound)return;link.dataset.kitchenBound='true';link.addEventListener('click',()=>{if(!select)return;const option=Array.from(select.options).find(o=>o.dataset.kitchenOption===link.dataset.kitchenChoice);if(option){select.value=option.value;select.dispatchEvent(new Event('change',{bubbles:true}));}});});const feedback=root.querySelector('[data-room-feedback]');if(feedback&&!feedback.dataset.kitchenFocused){feedback.dataset.kitchenFocused='true';feedback.focus({preventScroll:true});feedback.scrollIntoView({block:'center'});}}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initKitchenQuote);else initKitchenQuote();
document.addEventListener('shopify:section:load',initKitchenQuote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stact-room-product"]) return;
  try {
    
function initRoomQuote(){
 const root=document.querySelector('.stact-room');if(!root)return;
 root.querySelectorAll('[data-room-choice]').forEach(link=>{
  if(link.dataset.roomBound)return;link.dataset.roomBound='true';
  link.addEventListener('click',()=>{
   
   const select=root.querySelector('[data-room-select]');if(!select)return;
   const option=Array.from(select.options).find(o=>o.dataset.roomOption===link.dataset.roomChoice);
   if(option){select.value=option.value;select.dispatchEvent(new Event('change',{bubbles:true}));}
  });
 });
 const feedback=root.querySelector('[data-room-feedback]');if(feedback&&!feedback.dataset.roomFocused){feedback.dataset.roomFocused='true';feedback.focus({preventScroll:true});feedback.scrollIntoView({block:'center'});}
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initRoomQuote);else initRoomQuote();
document.addEventListener('shopify:section:load',initRoomQuote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stact-sliding-product"]) return;
  try {
    
function initSlidingQuote() {
 const root = document.querySelector('.stact-sliding');
 if (!root) return;
 const select = root.querySelector('[data-sliding-select]');
 root.querySelectorAll('[data-sliding-choice]').forEach(link => {
  if (link.dataset.slidingBound) return;
  link.dataset.slidingBound = 'true';
  link.addEventListener('click', () => {
   if (!select) return;
   const option = Array.from(select.options).find(item => item.dataset.slidingOption === link.dataset.slidingChoice);
   if (option) select.value = option.value;
  });
 });
 const feedback = root.querySelector('[data-sliding-feedback]');
 if (feedback && !feedback.dataset.slidingFocused) {
  feedback.dataset.slidingFocused = 'true';
  feedback.focus({preventScroll: true});feedback.scrollIntoView({block: 'center'});
 }
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initSlidingQuote);
else initSlidingQuote();
document.addEventListener('shopify:section:load', initSlidingQuote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stact-station-product"]) return;
  try {
    
function initStationFeedback(){const root=document.querySelector('.stact-station');if(!root)return;const feedback=root.querySelector('[data-room-feedback]');if(feedback&&!feedback.dataset.stationFocused){feedback.dataset.stationFocused='true';feedback.focus({preventScroll:true});feedback.scrollIntoView({block:'center'});}}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initStationFeedback);else initStationFeedback();
document.addEventListener('shopify:section:load',initStationFeedback);

  } catch(e) { console.error(e); }
})();
})();
